export default {"src":"/_next/static/media/Illinois.1879a4cd.svg","height":1103,"width":800,"blurWidth":0,"blurHeight":0};